<template>
  <div class="fixed flex inset-0 z-10 bg-black bg-opacity-75">
    <div class="flex self-center items-center justify-center w-full h-full p-8">
      <div 
      class="
            flex flex-col
            overflow-hidden
            bg-white
            rounded
            w-full
            max-h-full  max-w-screen-lg
          " 
          :class="width"
          >
        <!-- Header -->
        <div class="flex items-center justify-between p-6 border-b">
          <div class="block">
            <h3 class="text-subheader-font-size font-semibold text-black">
              {{ ticket.subject }}
            </h3>
            <h4 class="text-sm text-black">
              {{ ___("Helpdesk|Ticket Number|content") }}:
              {{
                ticket.ticketNumber
              }}
            </h4>
          </div>
          <button 
          type="button" 
          class="btn-close text-3xl outline-none focus:outline-none" 
          @click="close"
          >
            x
          </button>
        </div>

        <!-- Content -->
        <div class="relative overflow-y-auto p-6">
          <div class="mb-3 pb-3 ticket border-b border-solid border-gray-300">
            <h3 class="py-2 headline">{{ ___("Helpdesk|Ticket Details|content") }}</h3>
            <div v-if="ticket.document.length > 0" class="mb-3">
              <span class="font-bold ">{{ ___("Helpdesk|Documents|content") }}</span>:
              <div class="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <div v-for="(ticketdocument, td) in ticket.document" :key="td">
                  <img class="w-full object-contain h-56" v-if="ticketdocument.mediaType.startsWith('image/')"
                    :src="`/ticket-document/${ticketdocument.id}`" :alt="ticketdocument.name">
                  <a target="_blank" class="underline cursor-pointer" v-if="ticketdocument.mediaType == 'text/plain'"
                    :href="`/ticket-document/${ticketdocument.id}`">{{ ticketdocument.name }}</a>
                  <a target="_blank" class="underline cursor-pointer" v-if="ticketdocument.mediaType == 'text/html'"
                    :href="`/ticket-document/${ticketdocument.id}`">{{ ticketdocument.name }}</a>
                  <div class="flex" v-if="ticketdocument.mediaType.startsWith('application/pdf')">
                    <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-6 mr-1 inline-block"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                          />
                        </svg>
                    <a target="_blank" class="file-pdf underline cursor-pointer"
                    v-if="ticketdocument.mediaType.startsWith('application/pdf')"
                    :href="`/ticket-document/${ticketdocument.id}`">{{ ticketdocument.name }}</a>
                  </div>
                 
                  <video v-if="ticketdocument.mediaType.startsWith('video/')" controls width="250">
                    <source :src="`/ticket-document/${ticketdocument.id}`" type="video/mp4">
                  </video>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
              <div>
                <div class="mb-3 p-1"><span class="font-bold ">{{ ___("Helpdesk|Description|content") }} </span>:<p v-html="ticket.description "></p></div>
                <p v-if="!hideTicketSeverity" class="p-1"><span class="font-bold" >{{ ___("Helpdesk|Ticket Priority|content") }} </span> :{{ ticketName(ticket.ticketPriorityId) }}</p>
                <p class="p-1"><span class="font-bold" > {{ ___("Helpdesk|Ticket Status|content") }} </span> :{{ ticketStatusName(ticket.ticketStatusId)}}</p>
                <p class="p-1"><span class="font-bold" >{{ ___("Helpdesk|Agent|content") }} </span>:
                  <span v-if="ticket.agent">{{ ticket.agent}}</span>
                  <span v-else>{{ ___("Helpdesk|Not Assigned Yet|content") }}</span>
                </p>
                <p class="p-1"><span class="font-bold" >{{ ___("Helpdesk|Person Responsible|content") }} </span>:
                  <span v-if="ticket.responsibleUser">{{ ticket.responsibleUser}}</span>
                  <span v-else>{{ ___("Helpdesk|Not Assigned Yet|content") }}</span>
                </p>
                <p class="p-1">
                  <span class="font-bold" >{{ ___("Helpdesk|Category|content") }}</span> :
                  <span  v-if="ticket.ticketCategoryId">
                    {{ ticketCategoryName(ticket.ticketCategoryId)}}
                  </span>
                  <span v-else>
                    {{ ___("General|-|content") }}
                  </span>
                </p>
              </div>
              <ul>
                <li v-for="(shownAttribute,att) in ticketAttributesOnDetail" :key="att+1000" class="p-1">
                  <span class="font-bold" v-if="shownAttribute.labelDE">
                    {{shownAttribute.labelDE}}
                  </span>
                  <span class="font-bold"  v-else-if="shownAttribute.labelEN">
                    {{shownAttribute.labelEN}}
                  </span>
                  <span class="font-bold"  v-else>
                    {{shownAttribute.labelFR}}
                  </span>
                  :
                  <span v-if="getAttributeValue(shownAttribute.custom_field_id,shownAttribute.selectableValues,ticket.customAttributes)">
                    {{getAttributeValue(shownAttribute.custom_field_id,shownAttribute.selectableValues,ticket.customAttributes)}}
                  </span>
                  <span v-else>
                    -
                  </span>
                </li>
              </ul>
            </div>
            <div v-if="ticket.ticketRating" class="flex p-1">
              <span class="font-bold" >{{ ___("Helpdesk|Ticket rating|content") }} </span> : 
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6" v-for="i in 5" :key="i"  :class="getStarRating(i,ticket.ticketRating)"  :fill="getStarRating(i,ticket.ticketRating) =='text-black' ? 'none' : 'currentColor'">
                <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
              </svg> 
            </div>
            <div v-if="ticketReferenceIsEnabled && ticket.entityReferences.length > 0" class="flex p-1">
              <span class="font-bold" >{{ ___("Helpdesk|References|content") }}</span> : 
              <ul class="ml-2">
                <li v-for="(entityRef, key) in ticket.entityReferences" :key="key">
                  <a v-if="entityRef.entityName === 'salesOrder'" :href="'/gotobookkeeping/orders/'+ entityRef.entityId">
                    {{ ___("Helpdesk|Order|content") }} [{{ entityRef.entityId }}]
                  </a>
                  <a v-else-if="entityRef.entityName === 'shipment'" :href="'/gotobookkeeping/shipment/'+ entityRef.entityId">
                    {{ ___("Helpdesk|Shipment|content") }} [{{ entityRef.entityId }}]
                  </a>
                  <a v-else-if="entityRef.entityName === 'salesInvoice'" :href="'/gotobookkeeping/invoices/'+ entityRef.entityId">
                    {{ ___("Helpdesk|Invoice|content") }} [{{ entityRef.entityId }}]
                  </a>
                  <a v-else-if="entityRef.entityName === 'quotation'" :href="'/gotobookkeeping/quotation/'+ entityRef.entityId">
                    {{ ___("Helpdesk|Quotation|content") }} [{{ entityRef.entityId }}]
                  </a>
                  <a v-else-if="entityRef.entityName === 'article'" :href="'/gotoarticle/'+ entityRef.entityId">
                    {{ ___("Helpdesk|Article|content") }} [{{ entityRef.entityId }}]
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <form 
          v-if="type != 'history'" 
          class="w-full p-4 shadow-md bg-gray-300 mb-5" 
          @submit.prevent="submit"
          >
            <div>
              <label for="comment" class="text-lg text-black">
                {{ ___("Helpdesk|Add a comment|content") }}</label
                >
              <textarea 
              class="
                      w-full
                      h-20
                      p-2
                      border
                      rounded
                      focus:outline-none focus:ring-black focus:ring-1
                  "
                  v-model="usercomment"
                  name="comment"
                  :placeholder="___('Helpdesk|Enter your comment|content')"
                  ></textarea>
            </div>
            <Btn type="submit" class="mb-2 md:mb-0"  :class="
                     fileUploadErrorMessage !== ''
                  ? 'cursor-not-allowed '
                  : 'cursor-pointer '
              "  :disabled="fileUploadErrorMessage !== ''">
              {{ ___("Helpdesk|Save comment|content") }}
            </Btn>

            <input id="file-upload" type="file" name="filename" @input="handleSingleFileUpload" accept="image/png,image/jpg,image/jpeg,image/gif,video/mp4,video/avi,video/mov,application/pdf,application/exl,application/doc">
            <p class="text-red-600 pt-2" v-if="fileUploadErrorMessage">{{ fileUploadErrorMessage }}</p>
          </form>
          
          <div class="text-center mb-5" v-if="loadComment">
            <h2 class="text-xl font-semibold"> {{ ___("Helpdesk|Loading comment|content") }}</h2>
	          <p class="">{{ ___("Helpdesk|Loading comment body|content") }}</p>
          </div>
          
            <div v-for="(comment, c) in ticket.comments" :key="c">
              <div 
              class="
                    focus:outline-none
                    p-1
                    shadow
                    rounded
                    mb-3
                    relative
                    w-fit-content
                    max-w-xl	
                    " 
                    :class="
                      comment.authorUserId == helpDeskUser
                        ? '	bg-gray-300 ml-auto'
                        : 'bg-gray-200'
                    "
                    >
                <div class="flex justify-between items-center flex-wrap text-black mb-2">
                  <div class="flex">
                    <img class="rounded-full h-6 w-6 mr-2" :src="`/user-thumbnail/${comment.authorUserId}`" alt="file" @error="imageLoadError($event)">

                    <span 
                    v-if="comment.authorUserId == helpDeskUser" 
                    class="font-bold flex items-center">
                      {{ userMainAccountName }}
                    </span>
                    <span v-else class="font-bold flex items-center">
                      <span v-if="useUserEmail">
                        {{ comment.authorUserUsername }}
                      </span>
                      <span v-else> {{ comment.userName }}</span>
                    </span>
                  </div>
                  <span class="text-sm ml-20">{{
                    dateTime(comment.createdDate)
                  }}</span>
                </div>

                <p 
                class="focus:outline-none text-black font-normal" 
                v-html="comment.htmlComment"
                ></p>
                <p v-for="(document,d) in comment.document" :key="d">
                  <img class="w-40 h-28" v-if="document.mediaType.startsWith('image/')" :src="`/comment-document/${document.id}`" :alt="document.name">
                  <a target="_blank" class="underline cursor-pointer" v-if="document.mediaType =='text/plain'" :href="`/comment-document/${document.id}`">{{document.name}}</a>
                  <a target="_blank" class="underline cursor-pointer" v-if="document.mediaType =='text/html'" :href="`/comment-document/${document.id}`">{{document.name}}</a>
                  <a target="_blank" class="file-pdf underline cursor-pointer" v-if="document.mediaType.startsWith('application/pdf')" :href="`/comment-document/${document.id}`">{{document.name}}</a>
                  <video v-if="document.mediaType.startsWith('video/')" controls width="250">
                    <source :src="`/comment-document/${document.id}`" type="video/mp4">
                  </video>
                </p>
                <div 
                :class="
                  comment.authorUserId == helpDeskUser
                    ? 'bubble-arrow alt'
                    : ' bubble-arrow'
                "
                ></div>
              </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="flex items-center justify-end p-6 border-t">
          <Btn class="mr-2" @onClick="close"> {{ ___("General|Close|content") }}</Btn>
        </div>
      </div>
    </div>
    <ConfirmationMessage :isAlertShown="isAlertShown" :alertType="commentCreationStatus" class="z-20">
      <template v-if="commentCreationStatus == 'Success'" v-slot:alert>
        {{ ___("Helpdesk|Comment Created|content") }}!
      </template>
      <template v-else v-slot:alert>
        {{ ___("Helpdesk|Comment Not Created|content") }}!
      </template>

      <template v-if="commentCreationStatus == 'Success'" v-slot:body>
        <p>{{ ___("Helpdesk|Comment Thanks Message|content") }}</p>
        <p>{{ ___("Helpdesk|Comment Ending Message|content") }}</p>
      </template>
      <template v-else v-slot:body>
        <p>{{ ___("Helpdesk|Comment Error Message|content") }}</p>
        <p>{{ ___("Helpdesk|Comment Ending Message|content") }}</p>
      </template>
    </ConfirmationMessage>
  </div>
</template>

<script >
import Btn from "@/Components/Btn";
import ConfirmationMessage from "@/Components/ConfirmationMessage";
import { Ticket } from "../../mixin/ticket";

export default {
  name: "TicketModal",
  components: {
    Btn,
    ConfirmationMessage
  },
  mixins: [Ticket],
  props: {
    width: String,
    ticket: Object,
    type:String,
  },
  data() {
    return {
      ticketID: this.ticket.id,
      loadComment:false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
   
    submit() {
      this.form.entityId = this.ticket.id;
      this.form.comment= `${this.usercomment} </br></br>By: ${this.userSubAccountName}, ID: ${this.userId}`;
      this.form.userEmail= this.userEmail;
      if( this.form.fileupload){
        this.form.fileName= this.form.fileupload['name'];
        this.form.fileType =this.form.fileupload['type'];
      }
      this.form.userID = this.helpDeskUser;

      this.usercomment = "";
      this.form.post('/sendcomment',{
        onSuccess: () => {
          this.$emit("loadComponent",this.ticketID,this.handleCommentComponentCallback);
          this.commentCreationStatus = this.$page.props.flash;
          this.loadComment = true;
          
          return Promise.all([
            this.form.reset(),
            (this.isAlertShown = !this.isAlertShown),
            setTimeout(() => {
              this.isAlertShown = !this.isAlertShown;
            }, 6000),
          ]);
        },
      });
    },
    handleCommentComponentCallback() {
      this.loadComment = false;
    },
  },
};
</script>

<style scoped>
.bubble-arrow {
  position: absolute;
  float: left;
  left: -11px;
  top: 0px;
}
.bubble-arrow.alt {
  top: 0;
  left: auto;
  right: 4px;
  float: right;
}
.bubble-arrow:after {
  content: "";
  position: absolute;
  border-top: 15px solid rgb(237, 242, 247);
  border-left: 15px solid transparent;
  border-radius: 4px 0 0 0px;
  width: 0;
  height: 0;
}
.bubble-arrow.alt:after {
  border-top: 15px solid rgb(226, 232, 240);
  transform: scaleX(-1);
}
</style>